/* eslint no-underscore-dangle: ["error", { "allow": ["_vwo_settings_timer", "_vwo_code"] }] */
import Settings from 'source/lib/settings_model';

const USE_EXISTING_JQUERY = true;
let FINISHED = false;
const BODY_STYLE = `body{
    opacity:0 !important;
    filter:alpha(opacity=0) !important;
    background:none !important;
}`;
const VWO_URL = '//dev.visualwebsiteoptimizer.com/j.php';

export default function loadVWO() {
    const {
        accountId,
        settingsTolerance,
        libraryTolerance,
    } = Settings.get('General.Vwo', {});

    if (!accountId) {
        return;
    }

    window._vwo_code = {
        use_existing_jquery() {
            return USE_EXISTING_JQUERY;
        },
        library_tolerance() {
            return libraryTolerance;
        },
        finish() {
            if (!FINISHED) {
                FINISHED = true;
                const a = document.getElementById('_vis_opt_path_hides');
                if (a) {
                    a.parentNode.removeChild(a);
                }
            }
        },
        finished() {
            return FINISHED;
        },
        load(src) {
            const script = document.createElement('script');
            script.src = src;
            script.type = 'text/javascript';
            // script.innerText;
            script.onerror = () => {
                this.finish();
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        },
        init() {
            const settingsTimer = setTimeout(this.finish, settingsTolerance);
            const style = document.createElement('style');
            const head = document.getElementsByTagName('head')[0];
            style.setAttribute('id', '_vis_opt_path_hides');
            style.setAttribute('type', 'text/css');
            if (style.styleSheet) {
                style.styleSheet.cssText = BODY_STYLE;
            } else {
                style.appendChild(document.createTextNode(BODY_STYLE));
            }
            head.appendChild(style);
            const url = encodeURIComponent(document.URL);
            this.load(`${VWO_URL}?a=${accountId}&u=${url}&r=${Math.random()}`);
            window._vwo_settings_timer = settingsTimer;
            return settingsTimer;
        },
    };
    window._vwo_code.init();
}
